import TrackedNavigate from './TrackedNavigate';

export type { TrackedNavigateProps } from './TrackedNavigate';
export default TrackedNavigate;
